import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/lib/Modal';
import IconClose from 'assets/icons/icon-close.svg';
import './modalComponent.scss';

export const ModalComponent = ({
    isOpen,
    onCancel,
    children,
    className,
    title,
    cancelText,
    confirmText,
    onConfirm,
    isConfirmDisabled,
}) => {
    const handleCancel = isCross => onCancel && onCancel({ isCross });
    const handleCancelCross = () => handleCancel(true);
    const handleCancelButton = () => handleCancel(false);

    return (
        <Modal
            show={isOpen}
            className={'ra-modal-override modal-component main-modal-component'}
            backdrop="static"
            animation={true}
            dialogClassName={className}
        >
            <Modal.Header>
                <div className="close-icon">
                    <button onClick={handleCancelCross}>
                        <img src={IconClose} alt="close-icon" />
                    </button>
                </div>
                {title && <div className="title">{title}</div>}
            </Modal.Header>

            <Modal.Body>
                <div>{children}</div>
            </Modal.Body>

            <Modal.Footer>
                <div className={`${className}-footer options-area`}>
                    {cancelText && (
                        <button className="close-button" onClick={handleCancelButton}>
                            {cancelText}
                        </button>
                    )}
                    {confirmText && (
                        <button
                            className="form__button form__button-secondary"
                            onClick={onConfirm}
                            disabled={isConfirmDisabled}
                        >
                            {confirmText}
                        </button>
                    )}
                </div>
            </Modal.Footer>
        </Modal>
    );
};

ModalComponent.propTypes = {
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    children: PropTypes.array,
    className: PropTypes.string,
    title: PropTypes.object,
    cancelText: PropTypes.object,
    confirmText: PropTypes.object,
    isConfirmDisabled: PropTypes.bool,
    extraContent: PropTypes.node,
};
